// extracted by mini-css-extract-plugin
export var header = "_s3-1";
export var maskBottom = "_s3-6";
export var maskMiddle = "_s3-7";
export var maskTop = "_s3-5";
export var root = "_s3-0";
export var scrollDownButton = "_s3-3";
export var scrollDownButtonHidden = "_s3-4";
export var viewport = "_s3-2";